import React from 'react';
import PropTypes from 'prop-types';
import {Box} from '@mui/material';

// Maria, 18 October 2026: the open sub-tab and the box under it look like one real tab. A 1px line in the green of the
// open tab goes round the tab and round the box, and is left open where the tab joins the box.
export const TAB_GREEN = '#0A8572';
// Maria, 19 October 2026: lighter on a staff profile, which sets --tab-outline
export const TAB_LINE_COLOUR = `var(--tab-outline, ${TAB_GREEN})`;
export const TAB_OUTLINE = `1px solid ${TAB_LINE_COLOUR}`;

// the box: no line along its top, as the top line is drawn in two parts either side of the open tab. It sits 1px higher,
// over the grey line under the tabs, so the open tab and the box join.
export const OUTLINED_BOX_SX = {
    position: 'relative',
    zIndex: 1,
    mt: '-1px',
    backgroundColor: '#fff',
    border: TAB_OUTLINE,
    borderTop: 'none',
    borderRadius: '0 0 8px 8px',
    boxSizing: 'border-box'
};

// Maria, 19 October 2026: a row of tabs inside the box that looks part of the open tab above: light green under the open
// tab, with the tab's outline carried down its right-hand side and then along its foot to the right-hand edge of the box
const X = 'var(--open-tab-end, 0px)';
export const BAND_UNDER_OPEN_TAB_SX = {
    backgroundImage: `linear-gradient(${TAB_LINE_COLOUR}, ${TAB_LINE_COLOUR}), linear-gradient(${TAB_LINE_COLOUR}, ${TAB_LINE_COLOUR}), linear-gradient(#e3f5f1, #e3f5f1)`,
    backgroundSize: `1px 100%, calc(100% - ${X}) 1px, ${X} 100%`,
    backgroundPosition: `${X} 0, ${X} 100%, 0 0`,
    backgroundRepeat: 'no-repeat'
};

// the top line of the box, either side of the open tab
export const TopLineAroundTab = ({openTab}) => {
    const line = {position: 'absolute', top: 0, height: '1px', backgroundColor: TAB_LINE_COLOUR, pointerEvents: 'none', zIndex: 2};
    if (!openTab) return <Box sx={{...line, left: 0, right: 0}}/>;
    return (
        <>
            {openTab.start > 0 && <Box sx={{...line, left: 0, width: `${openTab.start}px`}}/>}
            <Box sx={{...line, left: `${Math.max(0, openTab.end - 2)}px`, right: 0}}/>
        </>
    );
};

TopLineAroundTab.propTypes = {
    openTab: PropTypes.shape({start: PropTypes.number, end: PropTypes.number})
};
